import React, { Component } from "react";
import MyProvider from "./contexts/MyProvider";
import "./styles/main.scss";
import { TrainAdminSwitch } from "./infrastructure/TrainAdminSwitch";
import { TrainDefaultSwitch } from "./infrastructure/TrainDefaultSwitch";
import { BusAdminSwitch } from "./infrastructure/BusAdminSwitch";
import { BusDefaultSwitch } from "./infrastructure/BusDefaultSwitch";

export default class App extends Component {
  static displayName = App.name;

  constructor(props) {
    super(props);
    this.state = {
      mode: "",
      firstLoad: true,
      allowFileUploadExtension: [],
      totalCostSEKMax: "",
    };
  }

  render() {
    this.state.mode = window.__RUNTIME_CONFIG__.Mode;
    if (this.state.mode != "") {
      switch (this.state.mode) {
        case "admin.train":
        case "portal.train":
        case "public.train":
        case "admin":
        case "portal":
        case "public":
          return <MyProvider {...this.state}>{this.state.mode.includes("admin") ? <TrainAdminSwitch /> : <TrainDefaultSwitch />}</MyProvider>;
        case "admin.bus":
        case "portal.bus":
        case "public.bus":
          return <MyProvider {...this.state}>{this.state.mode.includes("admin") ? <BusAdminSwitch /> : <BusDefaultSwitch />}</MyProvider>;
        default:
          break;
      }
    }
    return "";
  }
}
